import { render } from "./CardMatricula.vue?vue&type=template&id=2a2b0fa6&scoped=true"
import script from "./CardMatricula.vue?vue&type=script&lang=js"
export * from "./CardMatricula.vue?vue&type=script&lang=js"

import "./CardMatricula.vue?vue&type=style&index=0&id=2a2b0fa6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2b0fa6"]])

export default __exports__